import styled from "styled-components";
import {JackpotBetPrizeContainerDefaultBox} from "./jp-bet-prize-container.default.box";
import {baseColors} from "../../../../../themes/definitions/mrgreen/base-colors";

export const JackpotBetPrizeContainerMRGBox = styled(JackpotBetPrizeContainerDefaultBox)`
  border: 1px solid ${baseColors.base02};
  border-radius: 4px;
  box-shadow: 0px 0px 6px 0px #04603F inset,
  0px 2px 6.9px 0px ${baseColors.base01Dark};
  background: ${baseColors.base01Dark};

`;
